const state = {
    unreadIds: []
}

const getters = {
    unreadNetworkingMessagesIds: state => state.unreadIds
}

const mutations = {
    setUnreadNetworkingMessagesIds: (state, unreadIds) => {
        state.unreadIds = unreadIds
    },

    addNetworkingMessage: (state, message) => {
        state.unreadIds.push({
            id: message.id,
            sender_id: message.sender_id
        })
    },

    removeNetworkingMessage: (state, message) => {
        state.unreadIds = state.unreadIds.filter(msg => {
            return msg.id != message.id
        })
    }
}

const actions = {
    fetchNetworkingNotifications: ({ commit, dispatch }) => {
        axios.get('/networking/notifications')
                .then(response => {
                    let unreadIds = response.data.unreadIds

                    commit('setUnreadNetworkingMessagesIds', unreadIds)
                })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}